import { logToSentry } from '@trinity/utils'
import { useRouteError } from 'react-router'
import { Typography } from '../Display'
import { Stack } from '../Layout'
import { Button } from '../Buttons'

const ERROR_MESSAGE = 'dynamically imported module'

export function ErrorHandler() {
  const error = useRouteError()
  const handleReload = () => window.location.reload()

  //* Implementing a workaround for the vite issue where modules are not imported correctly
  //* https://github.com/vitejs/vite/issues/11804
  if (error instanceof Error && error.message.toLocaleLowerCase().includes(ERROR_MESSAGE.toLocaleLowerCase())) {
    setTimeout(() => {
      handleReload()
    }, 1000)
  } else {
    logToSentry(error)
  }

  return (
    <Stack>
      <Typography variant='h4'>
        Something went wrong. Please click the button below to reload the page.
        <br /> If the problem persists, contact support.
      </Typography>
      {error instanceof Error && <Typography variant='body1'>{error.message}</Typography>}
      <Button onClick={handleReload}>Reload Page</Button>
    </Stack>
  )
}
